/* PA — fiche produit : supprime les paragraphes vides de la description (tous écrans)
   et, sur mobile uniquement : bulles vertes sous la description, vidéos JOIN centrées, « Complétez votre routine » après Actifs clés. */
(function(){
  var MQ='(max-width: 999px)';
  function emptyP(){
    document.querySelectorAll('.product-desc-block .desc > p, .product-desc-block .desc > div, .product-custom-description .desc > p, .product-custom-description .desc > div, .info--box .desc > p, .info--box .desc > div').forEach(function(p){
      if(p.dataset.paE)return;
      var t=(p.textContent||'').replace(/ /g,' ').trim();
      if(!t&&!p.querySelector('img,video,iframe')){p.style.display='none';p.dataset.paE='1';}
    });
  }
  function cleanBr(){
    var BLK=/^(P|DIV|H[1-6]|UL|OL|LI|TABLE|BLOCKQUOTE|SECTION|FIGURE)$/;
    function sig(n,dir){n=dir<0?n.previousSibling:n.nextSibling;while(n){if(n.nodeType===3&&!n.textContent.replace(/ /g,' ').trim()){n=dir<0?n.previousSibling:n.nextSibling;continue;}if(n.nodeType===1&&(n.dataset.paE||n.style.display==='none')){n=dir<0?n.previousSibling:n.nextSibling;continue;}return n;}return null;}
    document.querySelectorAll('.product-desc-block .desc, .product-custom-description .desc, .info--box .desc').forEach(function(d){
      d.querySelectorAll(':scope > strong, :scope > em, :scope > b, :scope > i, :scope > span, :scope > u').forEach(function(x){
        if(!x.dataset.paE&&!(x.textContent||'').replace(/ /g,' ').trim()&&!x.querySelector('img,video,iframe')){x.style.display='none';x.dataset.paE='1';}
      });
      var brs=[].slice.call(d.querySelectorAll(':scope > br'));
      for(var k=0;k<3;k++){brs.forEach(function(br){if(br.dataset.paE)return;var p=sig(br,-1),n=sig(br,1);
        if(!p||!n||(p.nodeType===1&&BLK.test(p.tagName))||(n.nodeType===1&&BLK.test(n.tagName))){br.style.display='none';br.dataset.paE='1';}});}
    });
  }
  function movePills(){
    var pills=null;document.querySelectorAll('.product-info .hero-claim-pills').forEach(function(x){if(!pills&&x.offsetParent!==null)pills=x;});
    if(!pills)return true;if(pills.dataset.paM)return true;
    var db=document.querySelector('.product-info [data-block-type="description"] .product-desc-block');
    if(!db||db.offsetParent===null)return false;
    db.parentNode.insertBefore(pills,db.nextSibling);pills.style.margin='16px 0 6px';pills.dataset.paM='1';return true;
  }
  function centerJoin(){
    var w=document.querySelector('.product-info [id^="widget-"]');if(!w)return true;
    var s=w.shadowRoot;if(!s||!s.querySelector('.join-widget-list'))return false;
    if(s.querySelector('style[data-pa]'))return true;
    var st=document.createElement('style');st.setAttribute('data-pa','1');
    st.textContent='.join-list.mobile{text-align:center!important}.join-list.mobile .join-widget-list{width:100%!important;box-sizing:border-box!important;margin-left:0!important;margin-right:0!important}.join-widget-list>li:first-child{margin-left:auto!important}.join-widget-list>li:last-child{margin-right:auto!important}';
    s.appendChild(st);return true;
  }
  function moveRoutine(){
    var r=document.querySelector('.pa-routine');if(!r)return false;if(r.dataset.paM)return true;
    var main=r.closest('.shopify-section');if(!main)return true;
    var after=null;document.querySelectorAll('.shopify-section[id$="__pa_actifs"]').forEach(function(s){if(!after&&s.offsetHeight>0)after=s;});
    if(!after)after=main;
    var wrap=document.createElement('div');wrap.className='container pa-routine-mob';wrap.style.cssText='padding-top:8px;padding-bottom:32px';
    after.parentNode.insertBefore(wrap,after.nextSibling);wrap.appendChild(r);r.dataset.paM='1';return true;
  }
  try{var css=document.createElement('style');css.textContent='@media (max-width: 999px){.hero-perks{height:46px!important}}';document.head.appendChild(css);}catch(e){}
  var n=0;
  function run(){
    n++;emptyP();cleanBr();
    var mob=window.matchMedia(MQ).matches,done=true;
    if(mob){var a=movePills(),b=moveRoutine(),c=centerJoin();done=a&&b&&c;}
    if(n<40&&(!done||n<6))setTimeout(run,300);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
})();

/* PA: barre « Ajouter au panier » flottante masquée (comme sur le site en ligne) */
(function(){if(document.getElementById('pa-no-sticky-atc'))return;var s=document.createElement('style');s.id='pa-no-sticky-atc';s.textContent='product-sticky-bar,.product-sticky-bar{display:none!important}';(document.head||document.documentElement).appendChild(s);})();
